import * as React from "react";
import { Query } from "react-apollo";
import { Helmet } from "react-helmet";
import { Row, Col, Button } from "reactstrap";
import { withToastManager } from "react-toast-notifications";

// GraphQL
import GetUserDetails from "../../GraphQL/Queries/GetUserDetails";

// Presentation/UI
import BackendWrapper from "../../Components/Layouts/BackendWrapper";
import Loader from "../../Components/Loader/DotLoader";
import GlobalModal from "../../Components/GlobalModal";

import AddCustomerForm from "./AddCustomerForm";
import AllCustomers from "./AllCustomers";

// Utils
import { getUserId } from "../../Utils/Helpers";

const userId = getUserId().userId;

interface IProps {
  toastManager: any;
}

class Customers extends React.Component<IProps> {
  state = {
    modal: false
  };

  // Close modal
  closeModal = (): void => {
    this.setState({
      modal: false
    });
  };

  // Open modal
  openModal = (): void => {
    this.setState({
      modal: true
    });
  };

  // success notification
  toastNotification = (message: string) => {
    this.props.toastManager.add(message, {
      appearance: "success",
      autoDismiss: true
    });
  };

  render() {
    return (
      <Query query={GetUserDetails} variables={{ id: userId }}>
        {({ loading, error, data }) => {
          if (loading) {
            return <Loader />;
          }
          if (error) {
            return <div>There was a problem loading the customers</div>;
          }

          const companyId = data.User.company.id;

          return (
            <BackendWrapper>
              <GlobalModal
                toggleModal={this.closeModal}
                title="Add Customer"
                modalDisplay={
                  <AddCustomerForm
                    companyId={companyId}
                    closeModal={this.closeModal}
                    notification={this.toastNotification}
                  />
                }
                modal={this.state.modal}
              />
              <Row>
                <Col xs={12} md={2} lg={2}>
                  <Button onClick={() => this.openModal()}>Add Customer</Button>
                </Col>
              </Row>
              <br />
              <br />
              <AllCustomers
                companyId={companyId}
                toastManager={this.props.toastManager}
              />
              <Helmet title="Customers" />
            </BackendWrapper>
          );
        }}
      </Query>
    );
  }
}

export default withToastManager(Customers);



// WEBPACK FOOTER //
// ./src/Containers/Customers/index.tsx